import { memo, useEffect, useState } from "react";
import ListUi from "./ListUi";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import MessageDilog from "../../components/MessageDilog";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useMemo } from "react";
import { Check } from "@mui/icons-material";
import { DEALERSHIP_STATUS } from "../../utils/constants/main";
import getDealershipApi, {
  updateDealershipField,
} from "../../apis/dealership.api";
import DealershipStatusComponent from "./DealershipStatusComponent";
import fileDownload from "js-file-download";

const ActionComponent = memo(({ params, setParams, callback }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const doneFun = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await updateDealershipField({ id: params._id }),
        (response) => {
          setParams({ ...params });
          callback(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
    dispatch(closeModal());
  };

  const onDone = () => {
    dispatch(
      openModal(
        <MessageDilog
          onSubmit={doneFun}
          title="Alert!"
          message={`Are you sure to your status is mark as complete "${
            params.first_name + " " + params.middle_name
          }" ?`}
        />,
        "sm"
      )
    );
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      {params.status == DEALERSHIP_STATUS.PENDING && (
        <Tooltip title="Mark As Completed">
          <IconButton disabled={loading} size="inherit" onClick={onDone}>
            <Check color="success" fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}

      {params.status == DEALERSHIP_STATUS.COMPLETE && "NA"}
    </Box>
  );
});

const ListController = () => {
  const dispatch = useDispatch();

  const title = "Dealership ";
  const fetchApi = getDealershipApi;
  const deleteApi = null;

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "name",
        label: "Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) =>
          params.first_name + " " + (params.middle_name ?? ""),
      },
      {
        id: 2,
        fieldName: "remarks",
        label: "Remarks",
        align: "left",
        sort: true,
        minWidth: "150px",
      },
      {
        id: 3,
        fieldName: "phone",
        label: "Phone",
        align: "left",
        sort: true,
        minWidth: "150px",
      },
      {
        id: 4,
        fieldName: "status",
        label: "Status",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => (
          <DealershipStatusComponent
            onlyview
            params={params}
            setParams={setParams}
          />
        ),
      },
      {
        id: 5,
        fieldName: "",
        label: "Action",

        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            deleteApi={deleteApi}
            params={params}
            callback={fetchList}
            setParams={setParams}
          />
        ),
      },
    ],
    [dispatch]
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["first_name", "middle_name"],
    sort: "",
    sortDirection: 1,
  });

  // do not change

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({});
  const [exportLoading, setexportLoading] = useState(false);

  const fetchList = (isExport) => {
    if (isExport) {
      setexportLoading(true);
      dispatch(
        callApiAction(
          async () => await fetchApi({ ...filters, csv: true }),
          (response) => {
            fileDownload(response, "dealership.csv");
            setexportLoading(false);
          },
          (err) => {
            setexportLoading(false);
          },
          true
        )
      );
    } else {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await fetchApi({ ...filters }),
          (response) => {
            setList(response);
            setLoading(false);
          },
          (err) => {
            setLoading(false);
          }
        )
      );
    }
  };

  useEffect(() => {
    fetchList();
  }, [filters]);

  return (
    <>
      <ListUi
        title={title}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        list={list}
        columns={columns}
        fetchList={fetchList}
      />
    </>
  );
};
export default ListController;
